import '../styles.css';
import { mountLearnPage } from '../ui/learn/page.js';
import { TIMING_PAGE } from './timing.js';

mountLearnPage(TIMING_PAGE);
